import {Accordion, AccordionButton, AccordionItem, AccordionPanel} from '@chakra-ui/react'
import "./accordionmenu.scss"
import {NavLink, useLocation} from "react-router-dom";
import React, {useEffect, useState} from "react";

export interface IAccordionMenu {
    buttonIcon: JSX.Element
    buttonText: string
    panelItems: { panelIcon: JSX.Element, panelText: string, panelLink: string, onClick: () => void }[]
}

const AccordionMenu = ({buttonIcon, buttonText, panelItems}: IAccordionMenu) => {
    const [openAccordion, setOpenAccordion] = useState<boolean>(false);
    let location = useLocation();
    useEffect(() => {
        panelItems.forEach(panelItem => {
            if (panelItem.panelLink === location.pathname) {
                setOpenAccordion(true)
                return;
            }
            return;
        })
    }, [openAccordion, location])

    return (
        <div className="Accordion-Menu">
            <Accordion defaultIndex={[openAccordion ? 0 : -1]} allowMultiple>
                <AccordionItem>
                    <AccordionButton className="nav-link">
                        {buttonIcon}
                        {buttonText}
                    </AccordionButton>
                    {
                        panelItems.map((panelItem, index) => {
                            return (
                                <AccordionPanel key={index}>
                                    <NavLink onClick={panelItem.onClick} className="nav-link" to={panelItem.panelLink}>
                                        {panelItem.panelIcon}
                                        {panelItem.panelText}
                                    </NavLink>
                                </AccordionPanel>
                            );
                        })
                    }
                </AccordionItem>
            </Accordion>
        </div>
    );
}

export default AccordionMenu;